class RecipesList {
    constructor() {
        this.section = document.querySelector('.block-recipes-list');
        this.filterTopic = document.getElementById('filter-topic');
        this.filterProduct = document.getElementById('filter-product');
        this.applyBtn = document.getElementById('apply-filters');
        this.clearBtn = document.getElementById('clear-filters');
        this.contentContainer = document.getElementById('recipes-content');
        this.loadingIndicator = document.getElementById('loading-indicator');
        this.prevBtn = document.getElementById('prev-btn');
        this.nextBtn = document.getElementById('next-btn');
        this.currentPageSpan = document.getElementById('current-page');
        this.lastPageSpan = document.getElementById('last-page');
        this.searchForm = document.getElementById('search-form');
        this.searchInput = document.getElementById('search-input');

        this.btnOpenFilter = this.section.querySelector('.btnOpenRecipesFilter')
        this.btnCloseFilter = this.section.querySelector('.btnCloseRecipesFilter')

        this.category = this.getCategoryFromURL();

        this.initializeFromURL();
        this.initializeFromDOM();
        this.initEvents();

        this.openFilter()
    }

    getCategoryFromURL() {
        const urlPath = window.location.pathname;
        const pathParts = urlPath.split('/');
        return pathParts[2] || '';
    }

    initializeFromURL() {
        const urlPath = window.location.pathname;
        const urlParams = new URLSearchParams(window.location.search);

        // Extrai a tag da URL se existir (/receitas/category/topico/tag)
        const pathParts = urlPath.split('/');
        if (pathParts.includes('topico') && pathParts[pathParts.indexOf('topico') + 1]) {
            this.currentTag = pathParts[pathParts.indexOf('topico') + 1];
            this.filterTopic.value = this.currentTag;
        } else {
            this.currentTag = '';
        }

        const productParam = urlParams.get('product');
        this.currentProduct = productParam || '';
        this.filterProduct.value = this.currentProduct;

        const pageParam = urlParams.get('page');
        this.currentPage = pageParam ? parseInt(pageParam) : 1;

        this.currentPageSpan.textContent = this.currentPage;
    }

    initializeFromDOM() {
        this.currentPage = parseInt(this.currentPageSpan.textContent) || 1;
        this.lastPage = parseInt(this.lastPageSpan.textContent) || 1;

        this.isPrevDisabled = this.prevBtn.hasAttribute('disabled');
        this.isNextDisabled = this.nextBtn.hasAttribute('disabled');

        this.updatePaginationState();
    }

    updatePaginationState() {
        // Atualiza estado dos botões baseado nas informações atuais
        this.prevBtn.disabled = this.currentPage <= 1 || this.isPrevDisabled;
        this.nextBtn.disabled = this.currentPage >= this.lastPage || this.isNextDisabled;

        // Atualiza estilos visuais
        if (this.prevBtn.disabled) {
            this.prevBtn.style.pointerEvents = 'none';
            this.prevBtn.style.opacity = '0.5';
        } else {
            this.prevBtn.style.pointerEvents = 'auto';
            this.prevBtn.style.opacity = '1';
        }

        if (this.nextBtn.disabled) {
            this.nextBtn.style.pointerEvents = 'none';
            this.nextBtn.style.opacity = '0.5';
        } else {
            this.nextBtn.style.pointerEvents = 'auto';
            this.nextBtn.style.opacity = '1';
        }
    }

    showLoading() {
        this.loadingIndicator.classList.remove('hidden');
        this.contentContainer.style.opacity = '0.5';
    }

    hideLoading() {
        this.loadingIndicator.classList.add('hidden');
        this.contentContainer.style.opacity = '1';
    }

    updateURL(tag = '', product = '', page = 1) {
        let url = `/receitas/${this.category}`;

        if (tag) {
            url += `/topico/${tag}`;
        }

        const params = new URLSearchParams();
        if (product) params.append('product', product);
        if (page > 1) params.append('page', page);

        if (params.toString()) {
            url += '?' + params.toString();
        }

        window.history.pushState({
            tag: tag,
            product: product,
            page: page
        }, '', url);
    }

    updatePagination(pagination) {
        this.currentPageSpan.textContent = pagination.current_page;
        this.lastPageSpan.textContent = pagination.last_page;

        this.currentPage = pagination.current_page;
        this.lastPage = pagination.last_page;
        this.isPrevDisabled = pagination.on_first_page;
        this.isNextDisabled = !pagination.has_more_pages;

        // Atualiza estado dos botões
        this.updatePaginationState();

        const paginationContainer = document.querySelector('.pagination');
        if (paginationContainer) {
            if (pagination.last_page <= 1) {
                paginationContainer.classList.add('hidden');
            } else {
                paginationContainer.classList.remove('hidden');
            }
        }
    }

    loadRecipes(tag = '', product = '', page = 1) {
        this.showLoading();

        const params = new URLSearchParams();
        if (tag) params.append('tag', tag);
        if (product) params.append('product', product);
        params.append('page', page);

        let apiUrl = '/receitas';
        if (this.category) {
            apiUrl += `/${this.category}`;
        }
        apiUrl += `/api?${params.toString()}`;

        fetch(apiUrl)
            .then(response => response.json())
            .then(data => {
                if (data.html.trim() === '') {
                    this.contentContainer.innerHTML = `
                        <div class="col-span-full py-6">
                            <p class="text-center text-lg text-dark">Nenhuma receita encontrada.</p>
                        </div>
                    `;
                } else {
                    this.contentContainer.innerHTML = data.html;
                }

                this.updatePagination(data.pagination);
                this.updateURL(tag, product, page);
                this.hideLoading();
            })
            .catch(error => {
                console.error('Erro ao carregar receitas:', error);
                this.contentContainer.innerHTML = `
                    <div class="col-span-full py-6">
                        <p class="text-center text-lg text-red-600">Erro ao carregar receitas. Tente novamente.</p>
                    </div>
                `;
                this.hideLoading();
            });
    }

    loadRecipesWithoutURL(tag = '', product = '', page = 1) {
        this.showLoading();

        const params = new URLSearchParams();
        if (tag) params.append('tag', tag);
        if (product) params.append('product', product);
        params.append('page', page);

        fetch(`/receitas/${this.category}/api?${params.toString()}`)
            .then(response => response.json())
            .then(data => {
                // Verifica se há conteúdo
                if (data.html.trim() === '') {
                    this.contentContainer.innerHTML = `
                        <div class="col-span-full py-6">
                            <p class="text-center text-lg text-dark">Nenhuma receita encontrada.</p>
                        </div>
                    `;
                } else {
                    this.contentContainer.innerHTML = data.html;
                }

                this.updatePagination(data.pagination);
                this.hideLoading();
            })
            .catch(error => {
                console.error('Erro ao carregar receitas:', error);
                this.contentContainer.innerHTML = `
                    <div class="col-span-full py-6">
                        <p class="text-center text-lg text-red-600">Erro ao carregar receitas. Tente novamente.</p>
                    </div>
                `;
                this.hideLoading();
            });
    }

    applyFilters() {
        this.currentTag = this.filterTopic.value;
        this.currentProduct = this.filterProduct.value;
        this.currentPage = 1;
        this.loadRecipes(this.currentTag, this.currentProduct, this.currentPage);
    }

    clearFilters() {
        this.filterTopic.value = '';
        this.filterProduct.value = '';
        this.searchInput.value = '';
        this.currentTag = '';
        this.currentProduct = '';
        this.currentSearch = '';
        this.currentPage = 1;
        this.loadRecipes('', '', 1);
    }

    initEvents() {
        this.applyBtn.addEventListener('click', () => {
            this.applyFilters();
            this.section.querySelector('.recipiesFilters').classList.remove('active')
        });

        this.clearBtn.addEventListener('click', () => {
            this.clearFilters();
        });

        this.searchForm.addEventListener('submit', (e) => {
            e.preventDefault();
            const searchTerm = this.searchInput.value.trim();

            if (searchTerm) {
                const searchParams = new URLSearchParams();
                searchParams.append('s', searchTerm);
                searchParams.append('source', 'receitas');

                window.location.href = `/busca?${searchParams.toString()}`;
            }
        });

        // Pagination events - Intercepta sempre
        this.prevBtn.addEventListener('click', (e) => {
            e.preventDefault();

            if (this.prevBtn.disabled || this.currentPage <= 1 || this.isPrevDisabled) {
                return;
            }

            this.loadRecipes(this.currentTag, this.currentProduct, this.currentPage - 1);
            this.section.scrollIntoView({ behavior: 'smooth' });
        });

        this.nextBtn.addEventListener('click', (e) => {
            e.preventDefault();

            if (this.nextBtn.disabled || this.currentPage >= this.lastPage || this.isNextDisabled) {
                return;
            }

            this.loadRecipes(this.currentTag, this.currentProduct, this.currentPage + 1);
            this.section.scrollIntoView({ behavior: 'smooth' });
        });

        // Browser back/forward buttons
        window.addEventListener('popstate', (event) => {
            if (event.state) {
                this.currentTag = event.state.tag || '';
                this.currentProduct = event.state.product || '';
                this.currentPage = event.state.page || 1;

                this.filterTopic.value = this.currentTag;
                this.filterProduct.value = this.currentProduct;

                this.loadRecipesWithoutURL(this.currentTag, this.currentProduct, this.currentPage);
            }
        });
    }

    openFilter() {
        this.btnOpenFilter.addEventListener('click', () => {
            this.section.querySelector('.recipiesFilters').classList.toggle('active')
            this.btnCloseFilter.addEventListener('click', () => {
                this.section.querySelector('.recipiesFilters').classList.toggle('active')
            })
        })
    }
}

if (document.querySelector('.block-recipes-list')) {
    new RecipesList();
}